// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__WWRxk","head":"Table_head__1Yhuo","col":"Table_col__2YXti"};